(function IIFE() {
    'use strict';

    /////////////////////////////

    function WidgetUserListSettingsController(
        $rootScope,
        $scope,
        $timeout,
        Content,
        Feed,
        User,
        UserPicker,
        Utils,
        Widget,
    ) {
        'ngInject';

        var widgetUserListSettings = this;

        /////////////////////////////
        //                         //
        //    Private attributes   //
        //                         //
        /////////////////////////////

        /**
         * The list key for the users list.
         *
         * @type {string}
         */
        var _listKey = 'widget-';

        /////////////////////////////
        //                         //
        //    Public attributes    //
        //                         //
        /////////////////////////////

        /**
         * The id of the user picker in the settings sidebar.
         *
         * @type {string}
         * @constant
         */
        widgetUserListSettings.PICKER_ID = 'widget-user-list-picker-';

        /**
         * Contains the list of field pickable for ordering the users list.
         *
         * @type {Array}
         */
        widgetUserListSettings.listOrderSelection = ['registrationDate', 'email', 'firstName', 'lastName'];

        /**
         * Contains the list of picked users id.
         *
         * @type {Array}
         */
        widgetUserListSettings.userList = [];

        /////////////////////////////

        /**
         * Services and utilities.
         */
        widgetUserListSettings.Feed = Feed;
        widgetUserListSettings.User = User;

        /////////////////////////////
        //                         //
        //     Public functions    //
        //                         //
        /////////////////////////////

        /**
         * Open the user picker.
         */
        function openUserPicker() {
            Utils.waitForAndExecute('#' + widgetUserListSettings.PICKER_ID, UserPicker);
        }

        /**
         * Update the widget each time the settings changes.
         */
        function updateWidget() {
            $timeout(function delayUpdateEventBroadcast() {
                $rootScope.$broadcast('widget-user-list-settings', Widget.getCurrent().uuid);
            });
        }

        /////////////////////////////

        widgetUserListSettings.openUserPicker = openUserPicker;
        widgetUserListSettings.updateWidget = updateWidget;

        /////////////////////////////
        //                         //
        //          Events         //
        //                         //
        /////////////////////////////

        /**
         * When the user picker closes, update the widget's picked users.
         *
         * @param {Event}  evt      The picker close event.
         * @param {string} pickerId The id of the picker beeing closed.
         */
        $scope.$on('user-picker__close-start', function onUserPickerCloseStart(evt, pickerId) {
            if (widgetUserListSettings.PICKER_ID === pickerId) {
                Widget.getCurrent().properties.usersIds = _.map(widgetUserListSettings.userList, 'id');
            }

            widgetUserListSettings.updateWidget();
        });

        /////////////////////////////

        /**
         * Initialize the controller.
         */
        function init() {
            var currentContent = Content.getCurrent();
            var currentWidget = Widget.getCurrent();
            var properties = currentWidget.properties || {};

            if (angular.isDefinedAndFilled(_.get(currentContent, 'id'))) {
                // We build the key from scratch here...
                _listKey = 'widget-' + currentWidget.uuid + '-' + currentContent.id;
                // ...so we need to add the '-pick' suffix.
                _listKey += '-' + (properties.type || 'pick');
            } else {
                // Here, we find the COMPLETE key that the directive already created.
                var userListKeys = Object.keys(User._services);

                var widgetUserListKey = _.find(userListKeys, function (key) {
                    return _.startsWith(key, 'widget-' + currentWidget.uuid);
                });
                if (angular.isDefinedAndFilled(widgetUserListKey)) {
                    // No need to add '-pick' because it's already part of the found key.
                    _listKey = widgetUserListKey;
                }
            }

            widgetUserListSettings.PICKER_ID += currentWidget.uuid;

            if (angular.isUndefinedOrEmpty(properties.type)) {
                properties.type = 'pick';
            }

            if (properties.type === 'pick' && angular.isUndefinedOrEmpty(properties.usersIds)) {
                properties.usersIds = [];
            }
        }

        // Run the initialization function to determine our _listKey.
        init();

        // Listen for any future updates that happen AFTER this controller is open.
        $scope.$on('widget:user-list-loaded', function (event, data) {
            if (data && data.listKey === _listKey) {
                widgetUserListSettings.userList = User.displayList(_listKey);
            }
        });

        widgetUserListSettings.userList = User.displayList(_listKey);

        // Make sure to keep any other event listeners you had, like 'user-picker__close-start'.
        $scope.$on('user-picker__close-start', function onUserPickerCloseStart(evt, pickerId) {
            if (widgetUserListSettings.PICKER_ID === pickerId) {
                Widget.getCurrent().properties.usersIds = _.map(widgetUserListSettings.userList, 'id');
            }
            widgetUserListSettings.updateWidget();
        });
    }

    /////////////////////////////

    angular.module('Controllers').controller('WidgetUserListSettingsController', WidgetUserListSettingsController);
})();
